import { PublishStatus } from '../../api/gerbera/core'
import moment from 'moment'

moment.locale('ja')

export interface PublishConfigData {
  category: {
    categoryId: number | null
  }
  status: PublishStatus
  publishedDate?: string
  expiresDate?: string
}

export interface CreateNewArticleConfigData {
  category: {
    categoryId: number | null
  }
  title?: string
}

export const OLDEST_DATE = moment('1900-01-01 00:00:00')
export const NO_EXPIRE = moment('9999-12-31 23:59:59')

export const PUBLISH_CONFIG_DRAFT: PublishConfigData = {
  category: {
    categoryId: null
  },
  status: 'pending',
  publishedDate: OLDEST_DATE.format(),
  expiresDate: OLDEST_DATE.format()
}
